import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class GeogFromText extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.geogfromtext',
        group: 'Parsers',
        title: 'ST Geog from Text',
        description: `
      This component creates a new column with geometries created from the values
      in another column. This column can contain geometries defined in both WKT or GeoJSON format.
      `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'textcol',
          type: WorkflowComponentParamType.Column,
          title: 'Text column with geography definition',
          parent: 'source',
          dataType: [ColumnDataType.String]
        }
      ]
    )
    this.supportedProviders = [Provider.BigQuery, Provider.Snowflake]
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery: {
        return dedent`SELECT ST_GEOGFROM(${params.textcol}) AS ${
          params.textcol
        }_geo, *
            FROM ${connection.quoteName(params.source as string)}`
      }
      case Provider.Snowflake: {
        return dedent`SELECT ST_GEOGFROMTEXT(${params.textcol}) AS ${
          params.textcol
        }_geo, *
            FROM ${connection.quoteName(params.source as string)}`
      }
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({
    columns,
    params,
    connection
  }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.textcol}_geo`,
      type: connection.getGeoDataType()
    })
  }
}

export { GeogFromText }
